import axios from "axios";
import { SITE } from "@/config/site";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const waLink = (text = "Hola, quiero asesorarme sobre planes de Isapre.") =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(text)}`;

export const PREVISIONES = ["Isapre", "Fonasa", "Otro"];
export const TIPOS_PLAN = ["Individual", "Familiar"];
export const REGIONES = [
  "Arica y Parinacota", "Tarapacá", "Antofagasta", "Atacama", "Coquimbo", "Valparaíso", "Metropolitana",
  "O'Higgins", "Maule", "Ñuble", "Biobío", "La Araucanía", "Los Ríos", "Los Lagos", "Aysén", "Magallanes",
];

export const formatError = (detail) => {
  if (!detail) return "Algo salió mal. Intenta nuevamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return "Revisa que los datos estén completos.";
  return detail.msg || String(detail);
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const offset = -((document.querySelector("header")?.offsetHeight ?? 80) + 8);
  if (window.__lenis) window.__lenis.scrollTo(el, { offset });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const http = axios.create({ baseURL: API });
